module.exports = __webpack_public_path__ + "static/img/a109.03622b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a109.jpg
// module id = a2+H
// module chunks = 0